import type { ArticleTileViewModel } from '@rocco/ui/tile-article/view-models/article';

/** The query param the directory's search field commits to. */
export const ARTICLE_SEARCH_PARAM = 'search';

/** One turn of the editorial grid: two rhythms of ten and their feature rows. */
export const ARTICLE_SEARCH_PAGE_SIZE = 24;

/**
 * How many pages a single deep link may hydrate.
 *
 * A search deep-linked at `?page=N` has to answer with pages 1..N or Back
 * from an article lands on a list shorter than the one the reader left. That
 * is one query at N times the page size, so the address bar is an input to
 * query cost and needs a ceiling: 20 pages is 480 articles, past any real
 * reading session and well short of anything that would hurt the service.
 */
export const ARTICLE_SEARCH_MAX_HYDRATED_PAGES = 20;

/**
 * What a search of the directory answers with. Shared by the loader that
 * serves the first page and the grid that asks for the rest, so it lives
 * outside the server module the search itself is in.
 */
export interface ArticleSearchResults {
    /** The term as searched, trimmed. */
    term: string;
    totalCount: number;
    /** 1-based, the page these articles are. */
    page: number;
    hasMore: boolean;
    articles: ArticleTileViewModel[];
    /** The service did not answer. Distinct from a term that matches nothing. */
    unavailable: boolean;
}
